import evaluations from "@/views/evaluations/evaluations.vue";
import evaluation from "@/views/evaluations/evaluation.vue";
import inReview from "@/views/evaluations/inReview.vue";
import reviewed from "@/views/evaluations/reviewed.vue";

export default [
    {
        path: "/evaluaciones",
        name: "Evaluations",
        component: evaluations,
        meta: {
            requiresAuth: true,
            roles: ['EvaluacionesAulaVirtual']
        }
    },
    {
        path: "/evaluaciones/por-revision",
        name: "inReview",
        component: inReview,
        meta: {
            requiresAuth: true,
            roles: ['EvaluacionesAulaVirtual']
        }
    },
    {
        path: "/evaluaciones/revisado",
        name: "reviewed",
        component: reviewed,
        meta: {
            requiresAuth: true,
            roles: ['EvaluacionesAulaVirtual']
        }
    },
    {
        path: "/evaluaciones/detail",
        name: "EvaluationDetail",
        component: evaluation,
        meta: {
            requiresAuth: true,
            roles: ['EvaluacionesAulaVirtual']
        }
    },
    { path: "/evaluaciones-*", redirect: { name: "ErrorPage" } }
];
